/**
 * Logger utility - substitui console.* em producao
 *
 * - debug/info/warn: so logam em DEV (import.meta.env.DEV)
 * - error: sempre loga (Sentry captura via console.error)
 */
/* eslint-disable no-console -- este arquivo ENCAPSULA console.* por design */
const logger = {
  debug: (...args: unknown[]) => {
    if (import.meta.env.DEV) console.log(...args)
  },
  info: (...args: unknown[]) => {
    if (import.meta.env.DEV) console.info(...args)
  },
  warn: (...args: unknown[]) => {
    if (import.meta.env.DEV) console.warn(...args)
  },
  error: (...args: unknown[]) => {
    console.error(...args)
  },
}

export default logger
